/* eslint-disable max-len */
import React, { useContext, useEffect, useState } from 'react'
import GlobalContext from '../../Context/GloablContext';
import { useAdminOrCorporateSearch } from '../../Context/adminCorporateSearch';
import AdvancedSearchInputBox from '../../AdvancedSearchInput/AdvancedSearchInputBox';
import DateInput from '../../DateField';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

export default function AdminCorporateAdvanceSearch({handleOnSubmit,emptyField,setEmptyField}) {
    const { advancedAdminCorSearch, setAdvancedAdminCorSearch,resetAdvancedAdminCorSearch } = useAdminOrCorporateSearch();
    
    const {isAdvancedSearchOpen,setIsAdvancedSearchOpen,isSideBar,setIsSideBar} = useContext(GlobalContext);
    const [searchParams,setSearchParams]=useSearchParams()

    const sidebarPrvState = useSelector(state => state?.systemConfigData?.sidebarPrvState)
    
    const handleOnChangeUserDetails = (id, value) => {
        let updatedValue = value;

        // Restrict input to only numbers, #, and * for specific fields
        if (id === 'mobile_number' || id === 'main_number' || id==='main_number_code' || id==='mobile_number_code') {
            updatedValue = value.replace(/[^0-9*-]/g, '');
        }

    
        // Handle only string values with trim, otherwise leave the value as is
        if (typeof updatedValue === 'string') {
            updatedValue = updatedValue.trim();
        }
    
        setAdvancedAdminCorSearch((prevState) => {
            const updatedState = { ...prevState, [id]: updatedValue };
    
            // Handle special cases for username and email (with two input fields)
            if (['user_name', 'user_name_domain'].includes(id)) {
                const isBothUserNameFieldsEmpty =
                    updatedState.user_name === '' && updatedState.user_name_domain === '';
                if (isBothUserNameFieldsEmpty && prevState.user_name_inverse === 'true') {
                    updatedState.user_name_inverse = '';
                }
            } else if (['email_address', 'email_address_domain'].includes(id)) {
                const isBothEmailFieldsEmpty =
                    updatedState.email_address === '' && updatedState.email_address_domain === '';
                if (isBothEmailFieldsEmpty && prevState.email_address_inverse === 'true') {
                    updatedState.email_address_inverse = '';
                }
            } else {
                // Uncheck mobile_number_inverse only if both fields are empty
                if ((id === 'mobile_number' || id === 'mobile_number_code') &&
                    updatedState.mobile_number.trim() === '' && 
                    updatedState.mobile_number_code.trim() === '' &&
                    prevState.mobile_number_inverse === 'true') 
                {
                    updatedState.mobile_number_inverse = '';
                }

                // Uncheck main_number_inverse only if both fields are empty
                if ((id === 'main_number' || id === 'main_number_code') &&
                    updatedState.main_number.trim() === '' && 
                    updatedState.main_number_code.trim() === '' &&
                    prevState.main_number_inverse === 'true') 
                {
                    updatedState.main_number_inverse = '';
                }

                // Default handling for other fields (uncheck checkbox if input is cleared)
                if (!['mobile_number', 'mobile_number_code', 'main_number', 'main_number_code'].includes(id) && updatedValue === '' && prevState[`${id}_inverse`] === 'true') 
                {
                    updatedState[`${id}_inverse`] = '';
                }

            }
    
            return updatedState;
        });
    };

    // handleSelect checkbox functions
    const handleCheckboxChange = (e, field) => {
        const { checked } = e.target;
    
        setAdvancedAdminCorSearch((prevState) => {
            let updatedState = { ...prevState };
    
            if (field === 'admin-user' || field === 'corporate-user') {
                // Update the user_type array
                let updatedUserTypes = [...prevState.user_type];
    
                if (checked) {
                    if (!updatedUserTypes.includes(field)) {
                        updatedUserTypes.push(field);
                    }
                } else {
                    updatedUserTypes = updatedUserTypes.filter((type) => type !== field);
                }
    
                // Uncheck inverse if array is empty
                if (updatedUserTypes.length === 0) {
                    updatedState.user_type_inverse = '';
                }
    
                return { ...updatedState, user_type: updatedUserTypes };
            } 
            else if (field === 'active' || field === 'inactive') {
                // Update the status array
                let updatedStatus = [...prevState.status];
    
                if (checked) {
                    if (!updatedStatus.includes(field)) {
                        updatedStatus.push(field);
                    }
                } else {
                    updatedStatus = updatedStatus.filter((type) => type !== field);
                }
    
                // Uncheck inverse if array is empty
                if (updatedStatus.length === 0) {
                    updatedState.status_inverse = '';
                }
    
                return { ...updatedState, status: updatedStatus };
            } 
            else {
                // Handle other fields as boolean values
                return { ...updatedState, [field]: checked ? 'true' : '' };
            }
        });
    };
    

    const dateformatSysconfig = useSelector(
        (state) => state?.systemConfigData?.globalVariables?.date_format
    );

    const [dateFormat, setDateFormat] = useState('dd/mm/yyyy');

    // Update date format from sysconfig
    useEffect(() => {
        if (dateformatSysconfig) {
            const format = dateformatSysconfig.split(',')[0].toLowerCase();
            setDateFormat(format === 'mm/dd/yyyy' ? 'mm/dd/yyyy' : 'dd/mm/yyyy');
        }
    }, [dateformatSysconfig]);
    
    const handleDateChange = (newDate) => {
        setEmptyField(false);
        // Validate input: only numbers, and apply limits
        const validatedDay = /^[0-9]*$/.test(newDate.day) && newDate.day <= 31 ? newDate.day : '';
        const validatedMonth = /^[0-9]*$/.test(newDate.month) && newDate.month <= 12 ? newDate.month : '';
        const validatedYear = /^[0-9]*$/.test(newDate.year) ? newDate.year : '';
    
        // Check if the date is fully cleared
        const isDateCleared =
            !validatedDay.trim() && !validatedMonth.trim() && !validatedYear.trim();
    
        setAdvancedAdminCorSearch((prevState) => ({
            ...prevState,
            created_day: validatedDay,
            created_month: validatedMonth,
            created_year: validatedYear,
            // Uncheck the checkbox if the date fields are cleared
            created_date_inverse: isDateCleared ? '' : prevState.created_date_inverse,
        }));
    };
    
    
    

    // Function to handle button click
    const handleCloseClick = () => {
    // Toggle the advanced search state
        setIsAdvancedSearchOpen(!isAdvancedSearchOpen)  
        // If previous sidebar state was true and isSideBar is currently false, set it to true
        if (sidebarPrvState === true && !isSideBar) {
            setIsSideBar(true);
        }
    };

    const isApplyButtonDisabled = () => {
        return Object.entries(advancedAdminCorSearch).every(([key, value]) => {
            if (key === 'match') return true; // Ignore 'match'
            return Array.isArray(value) ? value.length === 0 : value.trim() === ''; // Handle arrays and strings
        });
    };

    useEffect(() => {
        const params = Object.fromEntries(searchParams);
    
        if (params.search) {
            // Decode the search string to get individual fields
            const searchDecoded = decodeURIComponent(params.search);
    
            // Existing matches for user_id, first_name, and last_name and other states
            const userIdMatch = searchDecoded.match(/user_id=(ne:)?(.+?)(;|$)/);
            const firstNameMatch = searchDecoded.match(/first_name=(ne:)?(.+?)(;|$)/);
            const lastNameMatch = searchDecoded.match(/last_name=(ne:)?(.+?)(;|$)/);
            const userNameMatch = searchDecoded.match(/user_name=(ne:)?(.+?)(;|$)/);
            const emailMatch = searchDecoded.match(/email_address=(ne:)?(.+?)(;|$)/);
            const mobileNumberMatch = searchDecoded.match(/country_code2-mobile_number=(ne:)?(.+?)(;|$)/);
            const mainNumberMatch = searchDecoded.match(/country_code1-main_number=(ne:)?(.+?)(;|$)/);
            const userTypeMatches = [...searchDecoded.matchAll(/user_type=(ne:)?(.+?)(;|$)/g)];
            const statusMatches = [...searchDecoded.matchAll(/status=(ne:)?(.+?)(;|$)/g)];
            const createdDateMatch = searchDecoded.match(/created_at=(ne:)?(\d+)(;|$)/);


            // handle user_id field
            if (userIdMatch) {
                const isInverse = !!userIdMatch[1]; // Check if 'ne:' prefix is present
                const userIdValue = userIdMatch[2]; // Extract the user_id value after 'ne:'
        
                setAdvancedAdminCorSearch((prev) => ({
                    ...prev,
                    user_id: userIdValue === '__NULL__' ? '-' : userIdValue,
                    user_id_inverse: isInverse ? 'true' : '',
                }));
            }
            // Handle first_anme field

            if (firstNameMatch) {
                const isInverse = !!firstNameMatch[1];
                const firstNameValue = firstNameMatch[2];
        
                setAdvancedAdminCorSearch((prev) => ({
                    ...prev,
                    first_name: firstNameValue === '__NULL__' ? '-' : firstNameValue,
                    first_name_inverse: isInverse ? 'true' : '',
                }));
            }
            // Handle last_namee field
            if (lastNameMatch) {
                const isInverse = !!lastNameMatch[1];
                const lastNameValue = lastNameMatch[2];
        
                setAdvancedAdminCorSearch((prev) => ({
                    ...prev,
                    last_name: lastNameValue === '__NULL__' ? '-' : lastNameValue,
                    last_name_inverse: isInverse ? 'true' : '',
                }));
            }
    
            // Handle user_name field
            if (userNameMatch) {
                const isInverse = !!userNameMatch[1]; // Check if 'ne:' prefix is present
                const userNameValue = userNameMatch[2]; // Extract the user_name value after 'ne:'
                const [namePart, domainPart] = userNameValue.split('@');
    
                setAdvancedAdminCorSearch((prev) => ({
                    ...prev,
                    user_name: namePart==='__NULL__' ? '-' : namePart  || '', // Before '@' part
                    user_name_domain: domainPart==='__NULL__' ? '-' : domainPart || '', // After '@' part
                    user_name_inverse: isInverse ? 'true' : '', // Inverse checkbox
                }));
            }
            // Handle email_address field
            if (emailMatch) {
                const isInverse = !!emailMatch[1]; // Check if 'ne:' prefix is present
                const emailValue = emailMatch[2]; // Extract the email_address value after 'ne:'
                const [namePart, domainPart] = emailValue.split('@');

                setAdvancedAdminCorSearch((prev) => ({
                    ...prev,
                    email_address: namePart==='__NULL__' ? '-' : namePart  || '', // Before '@' part
                    email_address_domain: domainPart==='__NULL__' ? '-' : domainPart || '', // After '@' part
                    email_address_inverse: isInverse ? 'true' : '', // Inverse checkbox
                }));
            }
            // Handle mobile_number field
            if (mobileNumberMatch) {
                const isInverse = !!mobileNumberMatch[1];
                let mobileNumberValue = mobileNumberMatch[2];

                // Remove leading '+' if present
                if (mobileNumberValue.startsWith('+')) {
                    mobileNumberValue = mobileNumberValue.slice(1);
                }

                const [mobileCode, mobileNumber] = mobileNumberValue.split('-');

                setAdvancedAdminCorSearch((prev) => ({
                    ...prev,
                    mobile_number_code: 
            mobileCode === '__NULL__' ? '-' : mobileCode || '', 
                    mobile_number: 
            mobileNumber === '__NULL__' ? '-' : mobileNumber || '', 
                    mobile_number_inverse: isInverse ? 'true' : '',
                }));
            }

            // Handle main_number field
            if (mainNumberMatch) {
                const isInverse = !!mainNumberMatch[1];
                let mainNumberValue = mainNumberMatch[2];

                // Remove leading '+' if present
                if (mainNumberValue.startsWith('+')) {
                    mainNumberValue = mainNumberValue.slice(1);
                }

                const [mainCode, mainNumber] = mainNumberValue.split('-');

                setAdvancedAdminCorSearch((prev) => ({
                    ...prev,
                    main_number_code:
            mainCode === '__NULL__' ? '-' : mainCode || '',
                    main_number:
            mainNumber === '__NULL__' ? '-' : mainNumber || '',
                    main_number_inverse: isInverse ? 'true' : '',
                }));
            }


            // Handle user_type field (multiple occurrences possible)
            let userTypes = [];
            let isUserTypeInverse = false;

            userTypeMatches.forEach((match) => {
                const inversePrefix = match[1]; // 'ne:' if present
                const userTypeValue = match[2]; // Extract user_type value

                if (inversePrefix) {
                    isUserTypeInverse = true; // Set inverse if any occurrence has 'ne:'
                }
                userTypes.push(userTypeValue); // Add to the user_type array
            });

            if (userTypes.length > 0) {
                setAdvancedAdminCorSearch((prev) => ({
                    ...prev,
                    user_type: userTypes,
                    user_type_inverse: isUserTypeInverse ? 'true' : '',
                }));
            }

            // Handle status field (multiple occurrences possible)
            let status = [];
            let isStatusInverse = false;
            
            statusMatches.forEach((match) => {
                const inversePrefix = match[1]; // 'ne:' if present
                const statusValue = match[2]; // Extract user_type value
            
                if (inversePrefix) {
                    isStatusInverse = true; // Set inverse if any occurrence has 'ne:'
                }
                status.push(statusValue); // Add to the user_type array
            });
            
            if (status.length > 0) {
                setAdvancedAdminCorSearch((prev) => ({
                    ...prev,
                    status: status,
                    status_inverse: isStatusInverse ? 'true' : '',
                }));
            }

            //handle created date field
            if (createdDateMatch) {
                const isInverse = !!createdDateMatch[1]; // Check if 'ne:' prefix is present
                const epochTime = createdDateMatch[2]; // Extract the epoch time value
    
                const date = new Date(parseInt(epochTime, 10) * 1000); // Convert epoch to Date
                const day = date.getUTCDate().toString(); // Extract Day (1-31)
                const month = (date.getUTCMonth() + 1).toString(); // Extract Month (1-12)
                const year = date.getUTCFullYear().toString(); // Extract Year
    
                setAdvancedAdminCorSearch((prev) => ({
                    ...prev,
                    created_day: day,
                    created_month: month,
                    created_year: year,
                    created_date_inverse: isInverse ? 'true' : '', // Set inverse state
                }));
            }
    

            // Handle other params like search_mode if needed
            if (params.search_mode) {
                setAdvancedAdminCorSearch((prev) => ({
                    ...prev,
                    match: params.search_mode === 'or' ? true : false,
                }));
            }
        }
    }, [isAdvancedSearchOpen,searchParams]);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                handleClearAll();
            }
        };

        window.addEventListener("keydown", handleKeyDown);

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, []);

    
  
    /*** The `handleClearAll` function resets parameters and clears search-related fields.*/
    const handleClearAll = () => {
        resetAdvancedAdminCorSearch()
        const updatedParams = new URLSearchParams(searchParams);
        updatedParams.delete('search');
        updatedParams.delete('search_mode');
        setTimeout(()=>{
            setSearchParams(Object.fromEntries(updatedParams.entries()));
            setEmptyField(false);
        },300)
    };

    return (
        <div className='absolute top-0 left-0 w-[267px] rounded-tr-[12px] rounded-br-[12px] shadow-s7 h-[100dvh] bg-[#ffffff] z-[100]'>
            <form action='' 
                onSubmit={(e) => handleOnSubmit(e)} // Existing submit handler
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        e.preventDefault(); 
                        handleOnSubmit(e);
                    }
                }}
                className='w-full px-3 py-4'>
                <section className='flex justify-between items-center'>
                    <p className='text-sm font-semibold text-[#52555D]'>Advanced Search</p>
                    <button onClick={handleCloseClick}>
                        <img src="/images/cross_mark_gray.svg" alt="close-icon" loading='lazy' decoding='async' />
                    </button>
                </section>
                <section className='mt-4 flex items-center pb-4 border-b border-[#C5C9DA]'>
                    <p className='text-xs font-normal text-[#000000] pr-2'>Match:</p>
                    <div className='flex items-center'>
                        <div className='flex items-center'>
                            <div className="relative custom-radioBlue flex items-center">
                                <input id="match_any" type="radio" name="default-radio1" checked={advancedAdminCorSearch?.match} onChange={()=>handleOnChangeUserDetails("match",true)}/>
                                <label htmlFor="match_any" className={`text-xs font-normal ${advancedAdminCorSearch?.match ? 'text-[#000000]' : 'text-[#52555D]'} pl-6 pr-2 w-full cursor-pointer`}>
                                    Any
                                </label>
                            </div>
                            <div className='relative'>
                                <span className='any_hover'>
                                    <img src="/images/Tooltip.svg" alt="icon" loading='lazy' decoding='async' className='w-[15px] h-[15px]' />
                                </span>
                                <p className='bg-[#000000] bg-opacity-75 p-2 text-xs font-normal text-[#FFFFFF] transition-all absolute top-[25px] left-[0px] any_hover_text hidden rounded-lg w-[212px] z-[1]'>
                                    Displays results that match any of the input values. <br />
                                    Example: A OR B will return results that match either A, B, or both.
                                </p>
                            </div>
                        </div>
                        <div className='flex items-center ml-4'>
                            <div className="relative custom-radioBlue flex items-center ml-3" >
                                <input id="match_all"  type="radio" name="default-radio1" checked={!advancedAdminCorSearch?.match} onChange={()=>handleOnChangeUserDetails("match",false)}/>
                                <label htmlFor="match_all" className={`text-xs font-normal ${!advancedAdminCorSearch?.match ? 'text-[#000000]' : 'text-[#52555D]'} pl-6 pr-2 w-full cursor-pointer`}>
                                    All 
                                </label>
                            </div>
                            <div className='relative'>
                                <span className='any_hover'>
                                    <img src="/images/Tooltip.svg" alt="icon" loading='lazy' decoding='async' className='w-[15px] h-[15px]' />
                                </span>
                                <p className='bg-[#000000] bg-opacity-75 p-2 text-xs font-normal text-[#FFFFFF] transition-all absolute top-[25px] left-[0px] any_hover_text hidden rounded-lg w-[212px] z-[1]'>
                                    Displays results that match all of the input values. <br />
                                    Example: A AND B will only return results that match both A and B.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
                {emptyField && 
                    <p className='text-xs font-normal text-[#c52828] my-1 text-center'>Please fill the date field completely</p>
                }
                <div className='w-full flex items-center my-3'>
                    <div className='w-[170px] mr-2'>
                        <p className='text-xs font-normal text-[#52555D]'>Column Name & Value</p>
                    </div>
                    <div className='relative w-[65px] flex items-center'>
                        <p className='text-xs font-normal text-[#52555D]'>Inverse</p>
                        <span className='any_hover z-[99] ml-1'>
                            <img src="/images/Tooltip.svg" alt="icon" loading='lazy' decoding='async' className='w-[15px] h-[15px]' />
                        </span>
                        <p className='bg-[#000000] bg-opacity-75 p-2 text-xs font-normal text-[#FFFFFF] transition-all absolute top-[25px] left-[0px] any_hover_text hidden rounded-lg w-[212px] z-[10]'>
                            Excludes results that match the input value. <br />
                            Example: NOT A will return all results except those that match A.
                        </p>
                    </div>
                </div>
                <div className='-ml-2'>
                    <div className={`overflow-auto pl-2 ${emptyField?'h-[calc(100dvh-302px)]':'h-[calc(100dvh-285px)]'} scrollbar_purple`}>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2'>
                            <div className='w-[170px] mr-2'>
                                <AdvancedSearchInputBox
                                    label={"ID"}
                                    placeholder={"Enter ID"}
                                    id={"user_id"}
                                    data_testid={"user_id"}
                                    htmlFor={"user_id"}
                                    value={advancedAdminCorSearch.user_id}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                    maxLength={15}
                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='user_id_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'user_id_inverse')}
                                        checked={advancedAdminCorSearch.user_id_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={advancedAdminCorSearch?.user_id?.trim()===""}
                                    />
                                    <label htmlFor='user_id_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <p className='text-xs font-normal text-[#000000] mb-1 more-lines'>Username</p>
                                <div className='w-full flex items-center'>
                                    <AdvancedSearchInputBox
                                        label={""}
                                        placeholder={"example"}
                                        id={"user_name"}
                                        data_testid={"user_name"}
                                        htmlFor={"user_name"}
                                        value={advancedAdminCorSearch?.user_name}
                                        handleOnChangeInput={handleOnChangeUserDetails}
                                        maxLength={60}
                                    />
                                    <span className='mx-1 text-xs font-normal text-[#000000]'>@</span>
                                    <AdvancedSearchInputBox
                                        label={""}
                                        placeholder={"domain"}
                                        id={"user_name_domain"}
                                        data_testid={"user_name_domain"}
                                        htmlFor={"user_name_domain"}
                                        value={advancedAdminCorSearch.user_name_domain}
                                        handleOnChangeInput={handleOnChangeUserDetails}
                                        maxLength={60}
                                    />
                                </div>
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='user_name_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'user_name_inverse')}
                                        checked={advancedAdminCorSearch.user_name_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={advancedAdminCorSearch?.user_name_domain?.trim()===""&&advancedAdminCorSearch?.user_name?.trim()===""}
                                    />
                                    <label htmlFor='user_name_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <AdvancedSearchInputBox
                                    label={"First Name"}
                                    placeholder={"Enter first name"}
                                    id={"first_name"}
                                    data_testid={"first_name"}
                                    htmlFor={"first_name"}
                                    value={advancedAdminCorSearch?.first_name}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                    maxLength={60}
                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='first_name_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'first_name_inverse')}
                                        checked={advancedAdminCorSearch?.first_name_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={advancedAdminCorSearch?.first_name?.trim()===""}
                                    />
                                    <label htmlFor='first_name_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <AdvancedSearchInputBox
                                    label={"Last Name"}
                                    placeholder={"Enter last name"}
                                    id={"last_name"}
                                    data_testid={"last_name"}
                                    htmlFor={"last_name"}
                                    value={advancedAdminCorSearch?.last_name}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                    maxLength={60}
                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='last_name_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'last_name_inverse')}
                                        checked={advancedAdminCorSearch?.last_name_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={advancedAdminCorSearch?.last_name?.trim()===""}
                                    />
                                    <label htmlFor='last_name_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <p className='text-xs font-normal text-[#000000] mb-1 more-lines'>Type</p>
                                <div className='flex items-center'>
                                    <div className='p-[8px] flex items-center checkboxFocusAllignment mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                        <input
                                            type='checkbox'
                                            id='admin-user'
                                            onChange={(e) => handleCheckboxChange(e, 'admin-user')}
                                            checked={advancedAdminCorSearch.user_type.includes('admin-user')}
                                            className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        />
                                        <label htmlFor='admin-user' className='text-xs font-normal text-[#000] cursor-pointer'>
                                            Admin
                                        </label>
                                    </div>
                                    <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                        <input
                                            type='checkbox'
                                            id='corporate-user'
                                            onChange={(e) => handleCheckboxChange(e, 'corporate-user')}
                                            checked={advancedAdminCorSearch.user_type.includes('corporate-user')}
                                            className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        />
                                        <label htmlFor='corporate-user' className='text-xs font-normal text-[#000] cursor-pointer'>
                                            Corporate
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='type_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'user_type_inverse')}
                                        checked={advancedAdminCorSearch?.user_type_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={advancedAdminCorSearch?.user_type?.length === 0}
                                    />
                                    <label htmlFor='view' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <p className='text-xs font-normal text-[#000000] mb-1 more-lines'>Status</p>
                                <div className='flex items-center'>
                                    <div className='p-[8px] flex items-center checkboxFocusAllignment mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                        <input
                                            type='checkbox'
                                            id='active'
                                            onChange={(e) => handleCheckboxChange(e, 'active')}
                                            checked={advancedAdminCorSearch.status.includes('active')}
                                            className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        />
                                        <label htmlFor='active' className='text-xs font-normal text-[#000] cursor-pointer'>
                                            Active
                                        </label>
                                    </div>
                                    <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                        <input
                                            type='checkbox'
                                            id='inactive'
                                            onChange={(e) => handleCheckboxChange(e, 'inactive')}
                                            checked={advancedAdminCorSearch.status.includes('inactive')}
                                            className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        />
                                        <label htmlFor='inactive' className='text-xs font-normal text-[#000] cursor-pointer'>
                                            Inactive
                                        </label>
                                    </div>
                                </div>


                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='status_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'status_inverse')}
                                        checked={advancedAdminCorSearch?.status_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={advancedAdminCorSearch?.status?.length === 0}
                                    />
                                    <label htmlFor='view' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <p className='text-xs font-normal text-[#000000] mb-1 more-lines'>Email Address</p>
                                <div className='w-full flex items-center'>
                                    <AdvancedSearchInputBox
                                        label={""}
                                        placeholder={"example"}
                                        id={"email_address"}
                                        data_testid={"email_address"}
                                        htmlFor={"email_address"}
                                        value={advancedAdminCorSearch?.email_address}
                                        handleOnChangeInput={handleOnChangeUserDetails}
                                        maxLength={60}
                                    />
                                    <span className='mx-1 text-xs font-normal text-[#000000]'>@</span>
                                    <AdvancedSearchInputBox
                                        label={""}
                                        placeholder={"domain"}
                                        id={"email_address_domain"}
                                        data_testid={"email_address_domain"}
                                        htmlFor={"email_address_domain"}
                                        value={advancedAdminCorSearch?.email_address_domain}
                                        handleOnChangeInput={handleOnChangeUserDetails}
                                        maxLength={60}
                                    />
                                </div>
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='email_address_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'email_address_inverse')}
                                        checked={advancedAdminCorSearch?.email_address_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={advancedAdminCorSearch?.email_address?.trim()===""&&advancedAdminCorSearch?.email_address_domain.trim()===""}
                                    />
                                    <label htmlFor='email_address_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <p className='text-xs font-normal text-[#000000] mb-1 more-lines'>Mobile Number</p>
                                <div className='w-full flex items-center'>
                                    <span className='mr-1 text-xs font-medium text-[#000000]'>+</span>
                                    <div className='w-[40%]'>
                                        <AdvancedSearchInputBox
                                            label={""}
                                            placeholder={""}
                                            id={"mobile_number_code"}
                                            data_testid={"mobile_number_code"}
                                            htmlFor={"mobile_number_code"}
                                            value={advancedAdminCorSearch?.mobile_number_code}
                                            handleOnChangeInput={handleOnChangeUserDetails}
                                            maxLength={3}
                                        />
                                    </div>
                                    <span className='mx-0.5 text-xs font-normal text-[#000000]'></span>
                                    <AdvancedSearchInputBox
                                        label={""}
                                        placeholder={"Enter number"}
                                        id={"mobile_number"}
                                        data_testid={"mobile_number"}
                                        htmlFor={"mobile_number"}
                                        value={advancedAdminCorSearch?.mobile_number}
                                        handleOnChangeInput={handleOnChangeUserDetails}
                                        maxLength={20}
                                    />
                                </div>
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='mobile_number_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'mobile_number_inverse')}
                                        checked={advancedAdminCorSearch?.mobile_number_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={advancedAdminCorSearch?.mobile_number_code?.trim()==="" && advancedAdminCorSearch?.mobile_number?.trim()===""}
                                    />
                                    <label htmlFor='mobile_number_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <p className='text-xs font-normal text-[#000000] mb-1 more-lines'>Main Number</p>
                                <div className='w-full flex items-center'>
                                    <span className='mr-1 text-xs font-medium text-[#000000]'>+</span>
                                    <div className='w-[40%]'>
                                        <AdvancedSearchInputBox
                                            label={""}
                                            placeholder={""}
                                            id={"main_number_code"}
                                            data_testid={"main_number_code"}
                                            htmlFor={"main_number_code"}
                                            value={advancedAdminCorSearch?.main_number_code}
                                            handleOnChangeInput={handleOnChangeUserDetails}
                                            maxLength={3}
                                        />
                                    </div>
                                    <span className='mx-0.5 text-xs font-normal text-[#000000]'></span>
                                    <AdvancedSearchInputBox
                                        label={""}
                                        placeholder={"Enter number"}
                                        id={"main_number"}
                                        data_testid={"main_number"}
                                        htmlFor={"main_number"}
                                        value={advancedAdminCorSearch?.main_number}
                                        handleOnChangeInput={handleOnChangeUserDetails}
                                        maxLength={20}
                                    />
                                </div>
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='main_number_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'main_number_inverse')}
                                        checked={advancedAdminCorSearch?.main_number_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={advancedAdminCorSearch?.main_number_code?.trim()==="" && advancedAdminCorSearch?.main_number?.trim()===""}
                                    />
                                    <label htmlFor='main_number_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <DateInput
                                    labeltext={'Created Date'}
                                    date={{
                                        day: advancedAdminCorSearch.created_day,
                                        month: advancedAdminCorSearch.created_month,
                                        year: advancedAdminCorSearch.created_year,
                                    }}
                                    onDateChange={handleDateChange}
                                    dateFormat={dateFormat}
                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='created_date_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'created_date_inverse')}
                                        checked={advancedAdminCorSearch.created_date_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={advancedAdminCorSearch?.created_day?.trim()==="" || advancedAdminCorSearch?.created_month?.trim()==="" || advancedAdminCorSearch?.created_year?.trim()===""}
                                    />
                                    <label htmlFor='created_date_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='border-t border-[#C5C9DA]'>
                    <section className='mt-2'>
                        <p className='text-xs font-normal text-[#52555D]'>Note:</p>
                        <ol className='list-decimal pl-4 text-xs font-normal text-[#52555D]'>
                            <li>Use a dash (-) to indicate a null value.</li>
                            <li>Use an asterisk (*) as a wild-card character.</li>
                        </ol>
                    </section>
                </div>
                <div className="flex mt-[13px] justify-between">
                    <button 
                        id="Cancel"
                        type='button'
                        onClick={() => handleClearAll()}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.preventDefault(); // Prevent form submission
                                handleClearAll(); // Perform the clear action
                            }
                        }}
                        className="py-2.5 px-4 rounded-[16px] border border-[#972E4C] text-sm font-semibold text-[#972E4C] min-w-fit focus:bg-[#edc9d3]" 
                    >Clear All</button>
                    <button  
                        type='submit'
                        id="apply-filter"
                        disabled={isApplyButtonDisabled()}
                        className={`py-2.5 w-[106px] px-4 rounded-[16px]  disabled:bg-[#777C88] bg-[#972E4C] hover:bg-[#AB556E] border border-[#972E4C]'} text-sm font-semibold text-[#FFFFFF] hover:duration-75 reset_password_conf`}>
                        Apply
                    </button>
                </div>
            </form>
        </div>
    )
}
